/* tslint:disable */
/* eslint-disable */
/**
 * Micro Interactions B Service
 * API for micro-interactions
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  ApiCriteria,
  ApiCriteriaFromJSON,
  ApiCriteriaFromJSONTyped,
  ApiCriteriaToJSON,
} from './ApiCriteria';

/**
 *
 * @export
 * @interface ApiPetAttributeEligibilityMedicalConditions
 */
export interface ApiPetAttributeEligibilityMedicalConditions {
  /**
   * Holds a single Medical Condition that needs to be present in pet profile.
   * If this value is null then it means Pet Profile has no associated Medical Condition
   * @type {string}
   * @memberof ApiPetAttributeEligibilityMedicalConditions
   */
  value?: string;
  /**
   *
   * @type {ApiCriteria}
   * @memberof ApiPetAttributeEligibilityMedicalConditions
   */
  criteria?: ApiCriteria;
}

export function ApiPetAttributeEligibilityMedicalConditionsFromJSON(
  json: any,
): ApiPetAttributeEligibilityMedicalConditions {
  return ApiPetAttributeEligibilityMedicalConditionsFromJSONTyped(json, false);
}

export function ApiPetAttributeEligibilityMedicalConditionsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiPetAttributeEligibilityMedicalConditions {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    value: !exists(json, 'value') ? undefined : json['value'],
    criteria: !exists(json, 'criteria') ? undefined : ApiCriteriaFromJSON(json['criteria']),
  };
}

export function ApiPetAttributeEligibilityMedicalConditionsToJSON(
  value?: ApiPetAttributeEligibilityMedicalConditions | null,
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    value: value.value,
    criteria: ApiCriteriaToJSON(value.criteria),
  };
}
